import React from 'react';
import { Text, TextProps } from 'react-native';

import { useAppSelector } from '../app/hooks';
import { selectFontFamily } from '../features/appconfig/store/selectors';
import { getFontFamily } from '../helpers/fontMapper';
import { TextAlign } from '../models';

interface CustomTextProps extends TextProps {
  weight?: 'Regular' | 'Bold' | 'SemiBold';
  textAlign?: TextAlign;
}

const CustomText: React.FC<CustomTextProps> = ({
  children,
  style,
  weight = 'Regular',
  textAlign = 'left',
  ...props
}) => {
  const fontFamily = useAppSelector(selectFontFamily);
  const fontFamilyStyle = { fontFamily: getFontFamily(fontFamily, weight) };
  const textAlignStyle = { textAlign: textAlign };
  const robotoMonoStyle = fontFamily === 'RobotoMono' ? { letterSpacing: -1 } : {};
  return (
    <Text style={[fontFamilyStyle, textAlignStyle, style, robotoMonoStyle]} {...props}>
      {children}
    </Text>
  );
};

export default CustomText;
